import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

import { useLang, setLanguage } from '../../_metronic/i18n/Metronici18n'

import { Footer } from '../components/Footer'

const PublicLayout = () => {

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', 'dark')
  }, [])

  const intl = useIntl()

  const selectedLang = useLang()

  return (
    <div className="d-flex flex-column flex-root" style={{
      backgroundImage :"url('/images/main-background.png')",
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    }}>
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column flex-root flex-center mx-10 mx-md-0">
          <div className="d-flex flex-center flex-column w-100 w-lg-650px">
            <div className="d-flex flex-column flex-center pb-8 pt-8 pt-lg-0 pb-lg-12 px-5 px-md-15 w-100">
              <Link to="/">
                <img src="/images/logos/white-full-logo.svg" className="w-150px" alt=""/>
              </Link>
            </div>
            <div className="d-flex mx-5 mx-md-0 w-100 justify-content-center">
              <Outlet />
            </div>
            <div className="d-flex w-100 mt-10 mt-md-20 flex-md-row flex-column">
              <Footer className="d-flex me-md-auto"/>
              <div className="d-flex flex-center">
                <div className="d-flex me-4">
                  <button className="btn btn-flex btn-link btn-color-gray-700 btn-active-color-primary fs-base" onClick={()=>setLanguage(selectedLang === 'ar' ? 'en' : 'ar')}>
                    <i className="fa-solid fa-globe fs-8"></i>
                    <span className="text-muted">
                      {intl.formatMessage({id: `general.language_name.${selectedLang === 'ar' ? 'EN' : 'AR'}`})}
                    </span>
                  </button>
                </div>
                <Link to='/terms-of-service' className="text-muted me-4">{intl.formatMessage({id: `general.terms`})}</Link>
                <Link to='/privacy-policy' className="text-muted">{intl.formatMessage({id: `general.privacy`})}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {PublicLayout}
